module.exports = __webpack_public_path__ + "static/media/logo-white.6c11fbdc.svg";